import sliceCreator from '../../index.jsx';
import {GET_ALL_AREAS} from '../../../constants/index.jsx';
const _getAllAreasAction = sliceCreator('GET_ALL_AREAS', GET_ALL_AREAS, 'get');

const { asyncAction: getAllAreasAction, reducer, clearData: clearGetAllAreasAction } = _getAllAreasAction;

export default reducer;

export {
    getAllAreasAction,
    clearGetAllAreasAction
}